module.exports = __webpack_public_path__ + "img/claim-success.52325008.png";